import axios from 'axios';
import { API } from './constants';

const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

export const fetchCompanies = async (params = {}) => {
  const { data } = await api.get('/companies', { params });
  return data;
};

export const fetchCompany = async (id) => {
  const { data } = await api.get(`/companies/${id}`);
  return data;
};

export const fetchLeaderboard = async (params = {}) => {
  const { data } = await api.get('/leaderboard', { params });
  return data;
};

export const fetchConstructors = async (params = {}) => {
  const { data } = await api.get('/constructors', { params });
  return data;
};

export const fetchConstructorDetail = async (id, params = {}) => {
  const { data } = await api.get(`/constructors/${id}`, { params });
  return data;
};

export const fetchConstructorAnalytics = async (id, params = {}) => {
  const { data } = await api.get(`/constructors/${id}/analytics`, { params });
  return data;
};

export const fetchTop10 = async (category, country, completedOnly = false) => {
  const params = {};
  if (category) params.category = category;
  if (country) params.country = country;
  if (completedOnly) params.completed_only = true;
  const { data } = await api.get('/top10', { params });
  return data;
};

export const fetchRaces = async (params = {}) => {
  const { data } = await api.get('/races', { params });
  return data;
};

export const fetchRaceLeaders = async (raceId) => {
  const { data } = await api.get(`/races/${raceId}/leaders`);
  return data;
};

export const fetchF1Events = async (params = {}) => {
  const { data } = await api.get('/f1/events', { params });
  return data;
};

export const fetchNextRace = async () => {
  const { data } = await api.get('/f1/next-race');
  return data;
};


export const fetchF1RaceResults = async (raceId, params = {}) => {
  const { data } = await api.get(`/f1/races/${raceId}/results`, { params });
  return data;
};

export const fetchF1RaceComparison = async (raceId, params = {}) => {
  const { data } = await api.get(`/f1/races/${raceId}/comparison`, { params });
  return data;
};

export const fetchF1Standings = async (params = {}) => {
  const { data } = await api.get('/f1/standings', { params });
  return data;
};

export const fetchF1DriverBenchmarks = async (params = {}) => {
  const { data } = await api.get('/f1/driver-benchmarks', { params });
  return data;
};

export const fetchF1TeamBenchmarks = async (params = {}) => {
  const { data } = await api.get('/f1/team-benchmarks', { params });
  return data;
};

export const fetchF1RaceHistory = async (params = {}) => {
  const { data } = await api.get('/f1/race-history', { params });
  return data;
};

export const fetchCountries = async () => {
  const { data } = await api.get('/countries');
  return data;
};

export const fetchFilters = async (params = {}) => {
  const { data } = await api.get('/filters', { params });
  return data;
};

export const fetchStats = async (params = {}) => {
  const { data } = await api.get('/stats', { params });
  return data;
};

export const fetchCompare = async (ids) => {
  const { data } = await api.get('/compare', { params: { ids: ids.join(',') } });
  return data;
};

export const exportCSV = async (sector, country) => {
  const params = {};
  if (sector) params.sector = sector;
  if (country) params.country = country;
  const { data } = await api.get('/export/csv', { params, responseType: 'text' });
  return data;
};

export default api;
